import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Account } from '../../../../globals/store/accounts.data'
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from 'src/app/components/wrapper.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'new-account-dialog',
    template: `
      <div class="joi-dialog new-acc-dialog">
          <div mat-dialog-title>
             Welcome to Joi
          </div>
          <div mat-dialog-content>
              <div *ngIf="account?.created?.creatorUid === userService.uid">
                  <div class="dialog_content">
                      <div class="para">
                        Your new account name is:
                      </div>
                      <mat-progress-spinner color="primary" mode="indeterminate" *ngIf="!has_populated_name" [diameter]="18" ></mat-progress-spinner>
                      <div *ngIf="has_populated_name">
                        <mat-form-field class="general">
                            <input matInput name="account_name" [(ngModel)]="title" placeholder="Account Name">
                        </mat-form-field>
                        <div class="note">This can be updated later</div>
                      </div>
                  </div>
              </div>
              <div *ngIf="account?.created?.creatorUid !== userService.uid">
                <div class="dialog_content">
                  <div class="para">
                    You have access to the following account{{accountIds.length > 1 ? 's' : ''}}:
                  </div>
                  <div class="access_accounts" *ngFor="let id of accountIds">
                    {{ accounts[id]?.title }}
                  </div>
                </div>
              </div>
          </div>
          <div mat-dialog-actions class="lg">
              <button matButton="filled" color="primary" [disabled]="!title" (click)="updateAccount()">Continue</button>
          </div>
      </div>`,
    styles: [`
      .new-acc-dialog .para { margin-bottom: 15px; display:flex; }
      .new-acc-dialog .note { font-size: 12px; color: #999; }
      .new-acc-dialog .general { display: flex; align-items: center; padding-bottom: 10px; }
      .new-acc-dialog .access_accounts {font-weight: bold;  padding-bottom: 5px;}
  `],
  imports: [ CommonModule, MatProgressSpinnerModule, FormsModule, MatFormFieldModule, ReactiveFormsModule, MatInputModule, MatButtonModule],
    standalone: true,
})
export class NewAccountDialogComponent extends Wrapper<NewAccountDialogComponent> {

  account: Account
  accounts: Dictionary<Account> = {}
  accountIds: string[]
  title;
  accountId;
  original_first_title;
  has_populated_name = false;

  constructor(public dialogRef: MatDialogRef<NewAccountDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    super()
    this.take1(this.store.select('accounts', 'ids')).then(ids => {
      this.accountIds = <string[]>ids
      this.accountId = ids[0]
      this.subCallback(this.store.select('accounts', 'entities', this.accountId), account => {
        this.account = account
        this.original_first_title = account.title;
        if (!this.title) this.title = this.original_first_title;
        this.has_populated_name = true;
      })
    })
    
    this.subProp(this.store.select('accounts', 'entities'), 'accounts')
  }

  updateAccount() {
    this.dialogRef.close({ title_was_changed: this.original_first_title !== this.title, account: { id: this.accountId, title: this.title } });
  }
}
